<div class="sale-vet-list-result">
  <div class="table-responsive data-grid sticky-header-table sticky-header-table-height-sm mt-3 p-0" #tableVets>
    <table [dataSource]="dataSource"
           mat-table
           class="table table-hover"
           infiniteScroll
           [infiniteScrollDistance]="1"
           [infiniteScrollThrottle]="20"
           [infiniteScrollContainer]="tableVets"
           [fromRoot]="true"
           (scrolled)="onTableScroll()"
           [trackBy]="trackById" matSort="vetSort">
      <ng-container matColumnDef="checkbox">
        <th scope="col"
            class="checkbox-heading w-3-rem"
            mat-header-cell
            *matHeaderCellDef>
          <div class="custom-control custom-checkbox custom-checkbox-lg blank-label">
            <mat-checkbox (change)="$event ? masterToggle() : null" [checked]="selection.hasValue() && isAllSelected()"
                          [indeterminate]="selection.hasValue() && !isAllSelected()">
            </mat-checkbox>
            <label class="custom-control-label custom-control-label-all"
                   for="allCheckbox"></label>
          </div>
        </th>
        <td *matCellDef="let element; let saleHorseIndex = index"
            class="less-height-1-8-rem">
          <div class="custom-control custom-checkbox custom-checkbox-lg blank-label ps-3">
            <mat-checkbox (change)="onSingleChange($event,element)" [checked]="selection.isSelected(element)">
            </mat-checkbox>
            <label class="custom-control-label"
                   for="blankCheckbox-{{ saleHorseIndex }}"></label>
          </div>
        </td>
      </ng-container>

      <ng-container matColumnDef="firstName">
        <th mat-header-cell
            class="w-6-rem cursor-pointer"
            *matHeaderCellDef mat-sort-header>
          First <i class="fa fa-sort ms-1"></i>
        </th>
        <td mat-cell *matCellDef="let element">
          {{ element.firstName }}
        </td>
      </ng-container>

      <ng-container matColumnDef="lastName">
        <th mat-header-cell
            class="w-6-rem cursor-pointer"
            *matHeaderCellDef mat-sort-header>
          Last <i class="fa fa-sort ms-1"></i>
        </th>
        <td mat-cell *matCellDef="let element">
          {{ element.lastName }}
        </td>
      </ng-container>

      <ng-container matColumnDef="clinic">
        <th mat-header-cell
            class="w-8-rem cursor-pointer"
            *matHeaderCellDef mat-sort-header>
          Clinic <i class="fa fa-sort ms-1"></i>
        </th>
        <td mat-cell *matCellDef="let element">
          {{ element.clinic }}
        </td>
      </ng-container>

      <ng-container matColumnDef="email">
        <th mat-header-cell
            class="w-8-rem cursor-pointer"
            *matHeaderCellDef mat-sort-header>
          Email <i class="fa fa-sort ms-1"></i>
        </th>
        <td mat-cell *matCellDef="let element">
          {{ element.email }}
        </td>
      </ng-container>

      <ng-container matColumnDef="mobile">
        <th mat-header-cell
            class="w-8-rem cursor-pointer "
            *matHeaderCellDef mat-sort-header>
          Phone <i class="fa fa-sort ms-1"></i>
        </th>
        <td mat-cell *matCellDef="let element">
          {{ element.mobile }}
        </td>
      </ng-container>

      <ng-container matColumnDef="inDraft">
        <th mat-header-cell
            class="w-4-rem cursor-pointer content-center"
            *matHeaderCellDef mat-sort-header>
          IN DRAFT<i class="fa fa-sort ms-1"></i>
        </th>
        <td mat-cell *matCellDef="let element" class="vet-stats-text text-center">
          {{ element.inDraft }}
        </td>
      </ng-container>

      <ng-container matColumnDef="inReview">
        <th mat-header-cell
            class="w-4-rem cursor-pointer content-center"
            *matHeaderCellDef mat-sort-header>
          In Review<i class="fa fa-sort ms-1"></i>
        </th>
        <td mat-cell *matCellDef="let element" class="vet-stats-text text-center">
          {{ element.inReview }}
        </td>
      </ng-container>

      <ng-container matColumnDef="denied">
        <th mat-header-cell
            class="w-4-rem cursor-pointer content-center"
            *matHeaderCellDef mat-sort-header>
          Denied<i class="fa fa-sort ms-1"></i>
        </th>
        <td mat-cell *matCellDef="let element" class="vet-stats-text text-center">
          {{ element.denied }}
        </td>
      </ng-container>

      <ng-container matColumnDef="approved">
        <th mat-header-cell
            class="w-4-rem cursor-pointer content-center"
            *matHeaderCellDef mat-sort-header>
          Approved<i class="fa fa-sort ms-1"></i>
        </th>
        <td mat-cell *matCellDef="let element" class="vet-stats-text text-center">
          {{ element.approved }}
        </td>
      </ng-container>

      <ng-container matColumnDef="lotsViewed">
        <th mat-header-cell
            class="w-6-rem cursor-pointer content-center"
            *matHeaderCellDef mat-sort-header>
          Lots Viewed<i class="fa fa-sort ms-1"></i>
        </th>
        <td mat-cell *matCellDef="let element" class="vet-stats-text text-center">
          {{ element.lotsViewed }}
        </td>
      </ng-container>

      


      <ng-container matColumnDef="action">
        <th mat-header-cell
            class="action-heading w-3-rem"
            *matHeaderCellDef></th>
        <td mat-cell
            *matCellDef="let element"
            ngbDropdown
            placement="start">
          <button class="btn btn-outline-primary btn-sm"
                  (click)="vetProfileDetail(element)">
            <i class="fa fa-edit"></i>
          </button>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns$.value; sticky: true"></tr>
      <tr mat-row
          *matRowDef="
          let row;
          columns: displayedColumns$.value;
          let saleIndex = index
        "
          class="border-start-0 border-end-0 pointer pt-2"></tr>
    </table>

    <!--<div class="row" *ngIf="isLoaderSaleVets">
      <div class="col-md-12 text-center">
        Loading <i class="fa fa-spinner fa-spin"></i>
      </div>
    </div>-->
  </div>
</div>
